import Component from "vue-class-component";
import Vue from "vue";
import { Progress } from "@/commonui";
import { Layout, Divider } from "ant-design-vue";
const { Content } = Layout;

@Component({
	components: {
		Progress,
		Content,
		Divider
	}
})
export default class VcSplash extends Vue {}
